var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cc-loader"},[_vm._m(0),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_txt),expression:"show_txt"}]},[_vm._v(_vm._s(_vm.text || 'Carregando'))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-roller"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }